<template>
  <div class="hello1" v-if="showPreloader">
      <div class="preloader">
         <div class="loader-container">
            <p><img src="/img/pizza.gif" width="100" alt="" ></p>
            <p style="margin-top: -5px; animation: 1s ease-out 0s 1 slideInFromLeft;"><img src="img/logo-text.svg"  width="200" alt=""></p>
         </div>
      </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: 'PreLoader',
  computed: {
    ...mapGetters(["showPreloader"]),
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
